import { render } from "./GroupStratsPage.vue?vue&type=template&id=268988dd&scoped=true&ts=true"
import script from "./GroupStratsPage.vue?vue&type=script&lang=ts"
export * from "./GroupStratsPage.vue?vue&type=script&lang=ts"

import "./GroupStratsPage.vue?vue&type=style&index=0&id=268988dd&lang=scss&scoped=true"

import exportComponent from "/Users/edvardaskostkevicius/WebstormProjects/rv_frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-268988dd"]])

export default __exports__